<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h1>Gestión de Secciones</h1>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="openModal(null)">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nueva Sección
          </b-button>
        </b-col>
      </b-row>

      <b-table
        striped
        hover
        responsive
        class="mt-2"
        :items="sections"
        :fields="fields"
      >
        <template #cell(estado)="data">
          <b-badge :variant="data.value === 'Activo' ? 'light-success' : 'light-danger'">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button variant="gradient-primary" class="btn-icon" @click="openModal(data.item)">
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button variant="gradient-danger" class="btn-icon ml-1" @click="deleteSection(data.item)">
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <section-modal
      :section-data="selectedSection"
      @submit="handleModalSubmit"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge,
} from 'bootstrap-vue'
import SectionModal from '@/components/sections/SectionModal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    SectionModal,
  },
  data() {
    return {
      fields: [
        { key: 'codigo', label: 'Código', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      sections: [
        { id: 1, codigo: 'A', estado: 'Activo' },
        { id: 2, codigo: 'B', estado: 'Activo' },
        { id: 3, codigo: 'C', estado: 'Activo' },
        { id: 4, codigo: 'D', estado: 'Inactivo' },
      ],
      selectedSection: null,
    }
  },
  methods: {
    openModal(item) {
      this.selectedSection = item ? { ...item } : null
      this.$bvModal.show('section-modal')
    },
    handleModalSubmit(data) {
      if (data.id) {
        const index = this.sections.findIndex(s => s.id === data.id)
        if (index !== -1) this.sections.splice(index, 1, data)
      } else {
        const newId = this.sections.length ? Math.max(...this.sections.map(s => s.id)) + 1 : 1
        this.sections.push({ ...data, id: newId })
      }
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Operación Exitosa', icon: 'CheckIcon', variant: 'success', text: `La sección se ha ${data.id ? 'actualizado' : 'creado'} correctamente.`,
        },
      })
    },
    deleteSection(item) {
      this.$swal({
        title: '¿Estás seguro?',
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, ¡elimínala!',
        cancelButtonText: 'Cancelar',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const index = this.sections.findIndex(s => s.id === item.id)
          if (index !== -1) this.sections.splice(index, 1)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Eliminada', icon: 'TrashIcon', variant: 'success', text: 'La sección ha sido eliminada.',
            },
          })
        }
      })
    },
  },
}
</script>
